import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import PepeLogo from "@/components/PepeLogo";

const LINKS = [
  { id: "#lore", label: "Lore" },
  { id: "#tokenomics", label: "Tokenomics" },
  { id: "#roadmap", label: "Roadmap" },
  { id: "#how-to-buy", label: "How to Buy" },
  { id: "#community", label: "Community" },
];

export default function Navbar({ booted, onNavigate }) {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    onNavigate(id);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={booted ? { y: 0, opacity: 1 } : {}}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed inset-x-0 top-0 z-[100] border-b border-line bg-black/60 backdrop-blur-md"
      data-testid="navbar"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8">
        <button
          data-testid="nav-logo"
          onClick={() => go("#top")}
          className="flex items-center gap-3"
        >
          <PepeLogo className="h-8 w-8" />
          <span className="font-display text-sm font-extrabold tracking-widest text-neon">
            PEPE BUTT
          </span>
        </button>

        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => go(l.id)}
              className="glitch-hover font-mono text-xs tracking-[0.2em] text-[#9fb39f] uppercase transition-colors duration-200 hover:text-neon"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-buy-button"
            onClick={() => go("#how-to-buy")}
            className="border border-neon bg-neon px-5 py-2 font-mono text-xs font-bold tracking-[0.2em] text-nox uppercase transition-colors duration-200 hover:bg-transparent hover:text-neon"
          >
            BUY $PEPEBUTT
          </button>
        </nav>

        <button
          data-testid="nav-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="text-neon lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="overflow-hidden border-t border-line bg-black/90 backdrop-blur-md lg:hidden"
          >
            <div className="flex flex-col gap-1 px-5 py-4">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  onClick={() => go(l.id)}
                  className="py-3 text-left font-mono text-sm tracking-[0.2em] text-[#9fb39f] uppercase transition-colors duration-200 hover:text-neon"
                >
                  {l.label}
                </button>
              ))}
              <button
                data-testid="mobile-nav-buy-button"
                onClick={() => go("#how-to-buy")}
                className="mt-2 border border-neon bg-neon px-5 py-3 font-mono text-xs font-bold tracking-[0.2em] text-nox uppercase"
              >
                BUY $PEPEBUTT
              </button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
